import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FaPaperPlane } from 'react-icons/fa';

const ChatContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: calc(100vh - 200px);
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const ChatHeader = styled.div`
  padding: 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #ddd;

  h2 {
    margin: 0;
    color: #333;
  }

  p {
    margin: 5px 0 0 0;
    color: #666;
    font-size: 14px;
  }
`;

const ChatMessages = styled.div`
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const Message = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 70%;
  ${props => props.isSent ? 'align-self: flex-end;' : 'align-self: flex-start;'}
`;

const MessageContent = styled.div`
  padding: 10px 15px;
  border-radius: 15px;
  ${props => props.isSent 
    ? 'background: #007bff; color: white;' 
    : 'background: #f0f0f0; color: #333;'}
`;

const MessageTime = styled.span`
  font-size: 12px;
  color: #666;
  margin-top: 5px;
  ${props => props.isSent ? 'text-align: right;' : 'text-align: left;'}
`;

const ChatInput = styled.div`
  padding: 20px;
  border-top: 1px solid #ddd;
  display: flex;
  gap: 10px;
`;

const Input = styled.input`
  flex: 1;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 20px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
  }
`;

const SendButton = styled.button`
  background: #007bff;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: #0056b3;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
`;

const SupportChat = () => {
  const { t } = useTranslation();
  const [message, setMessage] = React.useState('');

  // This would normally come from props or a chat service
  const messages = [
    {
      id: 1,
      content: "Hello! How can I help you today?",
      timestamp: "10:00 AM",
      isSent: false,
    },
    {
      id: 2,
      content: "I have a question about my earnings from last week",
      timestamp: "10:02 AM",
      isSent: true,
    },
    {
      id: 3,
      content: "Sure, I'd be happy to help you with that. Could you please provide more details?",
      timestamp: "10:03 AM",
      isSent: false,
    },
  ];

  const handleSend = () => {
    if (message.trim()) {
      // Here you would normally send the message to your chat service
      console.log('Sending message:', message);
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && message.trim()) {
      handleSend();
    }
  };

  return (
    <ChatContainer>
      <ChatHeader>
        <h2>{t('dashboard.support.title')}</h2>
        <p>{t('dashboard.support.subtitle')}</p>
      </ChatHeader>

      <ChatMessages>
        {messages.map((msg) => (
          <Message key={msg.id} isSent={msg.isSent}>
            <MessageContent isSent={msg.isSent}>
              {msg.content}
            </MessageContent>
            <MessageTime isSent={msg.isSent}>
              {msg.timestamp}
            </MessageTime>
          </Message>
        ))}
      </ChatMessages>

      <ChatInput>
        <Input
          type="text"
          placeholder={t('dashboard.support.messagePlaceholder')}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <SendButton onClick={handleSend} disabled={!message.trim()}>
          <FaPaperPlane />
          <span>{t('dashboard.support.send')}</span>
        </SendButton>
      </ChatInput>
    </ChatContainer>
  );
};

export default SupportChat;
